<scaffold-dialog
  [title]="
    type === 'email'
      ? ('verify_email' | translation)
      : ('verify_phone' | translation)
  "
  [showCloseButton]="true"
  (close)="handleClose()">
  <div scaffoldDialogBody style="min-width: 400px">
    <ng-container *ngIf="isLoading; else verify">
      <div style="display: flex; justify-content: center">
        <app-loading-dots size="5px"></app-loading-dots>
      </div>
    </ng-container>

    <ng-template #verify>
      <p class="verify-instructions" *ngIf="type === 'email'">
        {{ 'verification_check_email' | translation }}
      </p>
      <p class="verify-instructions" *ngIf="type === 'phone_number'">
        {{ 'verification_check_phone' | translation }}
      </p>
      <app-input
        [disabled]="isProcessing"
        [control]="verificationCodeControl"
        [label]="'verification_code' | translation"
        [hideErrorContent]="true">
      </app-input>
    </ng-template>
  </div>
  <div scaffoldDialogButtons>
    <app-button *ngIf="!isLoading" status="secondary" (click)="handleClose()">
      {{ 'cancel' | translation }}
    </app-button>
    <app-button
      *ngIf="!isLoading"
      status="primary"
      (click)="sendVerificataion()"
      [isProcessing]="isProcessing">
      {{ 'submit' | translation }}
    </app-button>
  </div>
</scaffold-dialog>
